// ui/landingPage/calibrationLogsTab/slice.js

import { calibrationLogsTabUIInitialState } from "./uiLandingPageCalibrationLogsTabState";
import { makeCalibrationLogsTabUIActions } from "./uiLandingPageCalibrationLogsTabActions";

export const createCalibrationLogsTabUISlice = (set, get) => ({
  calibrationLogsTabUI: calibrationLogsTabUIInitialState,
  calibrationLogsTabUIActions: Object.freeze(
    makeCalibrationLogsTabUIActions(set, get)
  ),
});
